var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dropdown',{staticClass:"event-options"},[_c('span',{staticClass:"glyphicon glyphicon-option-horizontal clickable options-trigger",attrs:{"slot":"trigger"},slot:"trigger"}),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu show",attrs:{"slot":"options"},slot:"options"},[_c('li',[_c('ftp-sync-button')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }